import React, {useState} from 'react'
import PriceBadge from './PriceBadge'
import TopBadges from './TopBadges'
import ItemModal from './modals/ItemModal';

const SellerCard = ({data}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => {
    setIsModalOpen(true);
  };

  return (
    <>
    <div className='flex rounded-[3px] relative h-[350px] pb-[10px] bg-white w-full flex-col shadow-md cursor-pointer' 
        onClick={openModal}>
      <TopBadges/>
      <h1 className='font-bold text-2xl text-black pl-4 my-2'>{data.title}</h1>
      <img src={data.image} alt="Seller" className='object-cover h-[250px]' />
      <PriceBadge/>
    </div>
    {isModalOpen && (
      <ItemModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data={data} />
    )}
    </>
  )
}

export default SellerCard
